import { useRequest } from 'ahooks';
import { BuyerPageParams, getImportMaliciousBuyerHistory } from './service';
import { useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { message, ModalProps, Table } from 'antd';
import dayjs from 'dayjs';
import StatusButton from 'components/StatusButton';
import download from 'utils/download';
import StickyModal from 'components/StickyModal';

function ImportMaliciousBuyerHistoryModal({
  refreshKey,
  ...otherProps
}: ModalProps & {
  refreshKey: number;
}) {
  const { t } = useTranslate();

  const [page, setPage] = useState({
    pageNum: 1,
    pageSize: 10,
    total: 0,
  });

  const { loading, data, run } = useRequest(
    (params: BuyerPageParams = page) => {
      return getImportMaliciousBuyerHistory(params).then(({ records, total }) => {
        setPage({
          ...params,
          total,
        });
        return records;
      });
    },
    {
      ready: otherProps.visible,
      refreshDeps: [refreshKey],
      onError: () => message.error(t('phrase.获取数据失败，请稍后再试')),
    },
  );

  const table = (
    <Table
      loading={loading}
      dataSource={data}
      columns={[
        {
          key: 'userName',
          dataIndex: 'userName',
          title: t('操作账号'),
        },
        {
          key: 'importTimeInMs',
          dataIndex: 'importTimeInMs',
          title: t('bs_89'),
          render: (time: string) => dayjs(Number(time)).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
          key: 'result',
          title: t('导入结果'),
          render: (_, { failNum, successNum }) =>
            failNum ? (
              <div style={{ color: '#FF4747' }}>{t('失败x项', { count: failNum })}</div>
            ) : successNum ? (
              <div style={{ color: 'var(--fett-scenario-success-text)' }}>{t('成功')}</div>
            ) : (
              '-'
            ),
        },
        {
          key: 'resultUrl',
          dataIndex: 'resultUrl',
          title: t('操作'),
          render: (resultUrl: string) => (
            <StatusButton type="link" onClick={() => download(resultUrl)}>
              {t('下载明细')}
            </StatusButton>
          ),
        },
      ]}
      pagination={{
        size: 'small',
        simple: true,
        showQuickJumper: true,
        current: page.pageNum,
        pageSize: page.pageSize,
        total: page.total,
        onChange: (pageNum, pageSize) => run({ pageNum, pageSize }),
      }}
    />
  );

  return (
    <StickyModal width={850} title={t('trade.操作记录')} footer={false} {...otherProps}>
      {table}
    </StickyModal>
  );
}

export default ImportMaliciousBuyerHistoryModal;
